import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";

import css from "./Login.module.css";
import { UserContext } from "../../Context/UserContext";
import { Head } from "../../Utils/Head";
import { useForm } from "../../Hooks/useForm";
import { Button } from "../Forms/Button";
import { Input } from "../Forms/Input";
import { Error } from "../../Utils/Error";

export const LoginForm = () => {
  const { userLogin, loading, error, signInWithGoogle } =
    useContext(UserContext);
  const email = useForm("email");
  const password = useForm();
  const [signInWithMairimed, setSignInWithMairimed] = useState(true);

  async function handleSubmitLogin(event) {
    event.preventDefault();

    if (email.validate() && password.validate()) {
      userLogin(email.value, password.value);
    }
  }

  return (
    <section>
      <Head title="Login" />
      <h1 className="title">Sign In</h1>
      {/* <button onClick={signInWithGoogle} className={css.loginWithGoogleBtn}>
        Entrar com Google
      </button>
      <p>Ou</p>
      <button
        onClick={() => setSignInWithMairimed(!signInWithMairimed)}
        className={css.loginWithMairimedBtn}
      >
        Entrar com Mairini
      </button> */}
      {/* {signInWithMairimed && ( */}
      <form onSubmit={handleSubmitLogin}>
        <Input label="Email" type="email" name="email" {...email} />
        <Input label="Senha" type="password" name="password" {...password} />
        <Link className="textLink" to="/login/recover">
          Esqueceu a senha?
        </Link>
        <div className={css.loginForm}>
          {/* <Link className="textLink" to="/register">
            Criar conta
          </Link> */}
          {loading ? (
            <Button disabled>Loading...</Button>
          ) : (
            <Button>Enviar</Button>
          )}
          <Error error={error} />
        </div>
      </form>
      {/* )} */}
    </section>
  );
};
